import axios from 'axios';
import { getToken } from '@qlibs/react-components';

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
axios.defaults.timeout = 300000;

export const httpRequest = axios.create();
export const httpRequestMultipart = axios.create();

const getReportPdfTemporaryToken = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  if (!window.location.pathname.endsWith('/report-pdf')) {
    return null;
  }

  const params = new URLSearchParams(window.location.search);
  return params.get('temporaryToken');
};

const isUsingReportPdfTemporaryToken = () => {
  return Boolean(getReportPdfTemporaryToken());
};

const getRequestAuthorizationToken = () => {
  return getReportPdfTemporaryToken() || getToken();
};

httpRequest.interceptors.request.use(
  async (config: any) => {
    const authorizationToken = getRequestAuthorizationToken();

    config.headers = config.headers || {};
    config.headers['Content-Type'] = 'application/json';

    if (authorizationToken) {
      config.headers['Authorization'] = 'Bearer ' + authorizationToken;
    } else {
      delete config.headers['Authorization'];
    }

    return config;
  },
  (error) => {
    console.error('httpRequest: Error interceptor request:::', error.response);
    return Promise.reject(error);
  }
);

httpRequestMultipart.interceptors.request.use(
  async (config: any) => {
    const authorizationToken = getRequestAuthorizationToken();

    config.headers = config.headers || {};
    config.headers['Content-Type'] = 'multipart/form-data';

    if (authorizationToken) {
      config.headers['Authorization'] = 'Bearer ' + authorizationToken;
    } else {
      delete config.headers['Authorization'];
    }

    return config;
  },
  (error) => {
    console.error('httpRequest: Error interceptor request:::', error.response);
    return Promise.reject(error);
  }
);

httpRequest.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error(error);
    if (error && error.response) {
      const shouldForceLogout =
        !isUsingReportPdfTemporaryToken() &&
        (error.response.status === 403 ||
          error.response.status === 401 ||
          error.response.data?.code === 'err_unauthorized');

      if (shouldForceLogout) {
        // removeToken();
        localStorage.clear();
        window.location.href = '/login';
      }
      console.error(
        'httpRequest: Error interceptor response:::',
        error.response
      );
      return Promise.reject(error.response);
    } else {
      console.error(error);
    }
  }
);
